<div style="margin: 0 auto" class="sdk-sign-in-container">
    <div class="tk-margin-left-2t">
        <table class="tk-tabl-form-sip kc-sdk-tester-sign-in-table" role="presentation">
            <tbody>
                <tr>
                    <td class="sign-in-left-side">
                        <form [formGroup]="SignInService.signInForm" #ngForm="ngForm" method="post" novalidate (ngSubmit)="SdkTesterService.doSigninSubmit()">
                            <table class="sdk-login-table">
                                <tr>
                                    <td colspan="3">
                                        <h2 tabindex="-1">{{ inAdvancedMode ? 'Create Token' : 'Enter Info' }}</h2>
                                        <div class="icon-exclamationbox" *ngIf="SignInService.clientError.visible">
                                            {{ SignInService.clientError.content }}
                                        </div>
                                        <div class="icon-exclamationbox" *ngIf="SignInService.serverError.visible">
                                            {{ SignInService.serverError.content }}
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label tabindex="-1" for="kc-userNameInput" id="kc-userNameLblId" class="kc-label-padding">User name</label>
                                    </td>

                                    <td
                                        class="tk-rfrm-group"
                                        [ngClass]="{
                                            'tk-rfrm-has-error': userNameError || (SignInService.signInForm.controls['username'].invalid && ngForm.submitted)
                                        }">
                                        <div>
                                            <div class="tk-rfrm-columnar-container">
                                                <div class="tk-rfrm-error-container">
                                                    <input
                                                        class="tk-margin-left-min"
                                                        type="text"
                                                        spellcheck="false"
                                                        id="kc-userNameInput"
                                                        formControlName="username"
                                                        kc:focus-on-me="true"
                                                        autocomplete="off"
                                                        aria-required="true"
                                                        aria-autocomplete="none"
                                                        aria-describedby="signInField_inputTip UserName_errormessage"
                                                        [ngClass]="{
                                                            'tk-form-field-error':
                                                                userNameError || (ngForm.submitted && SignInService.signInForm.controls['username'].invalid),
                                                            '': SignInService.signInForm.controls['username'].valid
                                                        }"
                                                        (keyup)="
                                                            userNameError =
                                                                SignInService.signInForm.controls['username'].dirty &&
                                                                SignInService.signInForm.controls['username'].invalid
                                                                    ? true
                                                                    : false
                                                        "
                                                        (blur)="userNameError = SignInService.signInForm.controls['username'].invalid ? true : false"
                                                        required="true" />
                                                    <div class="small-dot kc-sdk-signin-required"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td
                                        [ngClass]="{
                                            'tk-rfrm-has-error': userNameError || (SignInService.signInForm.controls['username'].invalid && ngForm.submitted)
                                        }">
                                        <div>
                                            <div class="tk-rfrm-columnar-container">
                                                <div class="tk-rfrm-error-container">
                                                    <span
                                                        id="kc-userName_errormessage"
                                                        class="tk-padding-left-1t"
                                                        aria-required="true"
                                                        aria-invalid="true"
                                                        aria-describedby="User name is required"
                                                        *ngIf="
                                                            (SignInService.signInForm.controls['username'].dirty || ngForm.submitted) &&
                                                            SignInService.signInForm.controls['username'].invalid
                                                        ">
                                                        User name is required.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label tabindex="-1" for="kc-orgId" id="kc-orgLblId" class="kc-label-padding">Organization</label>
                                    </td>

                                    <td
                                        class="tk-rfrm-group"
                                        [ngClass]="{
                                            'tk-rfrm-has-error': orgError || (SignInService.signInForm.controls['organization'].invalid && ngForm.submitted)
                                        }">
                                        <div class="tk-rfrm-columnar-container">
                                            <div class="tk-rfrm-error-container">
                                                <input
                                                    class="tk-margin-left-min"
                                                    type="text"
                                                    id="kc-orgId"
                                                    formControlName="organization"
                                                    autocomplete="off"
                                                    aria-required="true"
                                                    aria-autocomplete="none"
                                                    aria-describedby="signInField_inputTip Org_errormessage"
                                                    [ngClass]="{
                                                        'tk-form-field-error':
                                                            orgError || (ngForm.submitted && SignInService.signInForm.controls['organization'].invalid),
                                                        '': SignInService.signInForm.controls['organization'].valid
                                                    }"
                                                    (keyup)="
                                                        orgError =
                                                            SignInService.signInForm.controls['organization'].dirty &&
                                                            SignInService.signInForm.controls['organization'].invalid
                                                                ? true
                                                                : false
                                                    "
                                                    (blur)="orgError = SignInService.signInForm.controls['organization'].invalid ? true : false"
                                                    required="true" />
                                                <div class="small-dot kc-sdk-signin-required"></div>
                                            </div>
                                        </div>
                                    </td>
                                    <td
                                        [ngClass]="{
                                            'tk-rfrm-has-error': orgError || (SignInService.signInForm.controls['organization'].invalid && ngForm.submitted)
                                        }">
                                        <div>
                                            <div class="tk-rfrm-columnar-container">
                                                <div class="tk-rfrm-error-container">
                                                    <span
                                                        id="kc-Org_errormessage"
                                                        class="tk-padding-left-1t"
                                                        aria-describedby="Organization is required"
                                                        aria-required="true"
                                                        aria-invalid="true"
                                                        *ngIf="
                                                            (SignInService.signInForm.controls['organization'].dirty || ngForm.submitted) &&
                                                            SignInService.signInForm.controls['organization'].invalid
                                                        ">
                                                        Organization is required.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="tester-sign-in-button-space">
                                        <button
                                            *ngIf="!inAdvancedMode"
                                            type="button"
                                            name="sdk-launch-kc-button"
                                            id="sdk-launch-kc-button"
                                            value="Launch KC"
                                            [disabled]="SignInService.busy"
                                            class="kc-tk-btn kc-tk-btn-primary tk-margin-left-min tk-margin-top-none tk-margin-bottom-none"
                                            (click)="SdkTesterService.launchKc()">
                                            Launch KC
                                        </button>
                                        <button
                                            name="generate_token"
                                            id="kc-generate_tokenBtnId"
                                            value="Generate_Token"
                                            enable-default="true"
                                            [disabled]="SignInService.busy"
                                            class="kc-tk-btn kc-tk-btn-primary tk-margin-left-min tk-margin-top-none tk-margin-bottom-none"
                                            label="whatever">
                                            {{ inAdvancedMode ? 'Generate Token' : 'Launch Encoder' }}
                                        </button>
                                        <button
                                            *ngIf="!inAdvancedMode"
                                            type="button"
                                            name="sdk-launch-references-button"
                                            id="sdk-launch-references-button"
                                            value="Launch References"
                                            [disabled]="SignInService.busy"
                                            class="kc-tk-btn kc-tk-btn-primary tk-margin-left-min tk-margin-top-none tk-margin-bottom-none"
                                            (click)="SdkTesterService.launchReferences()">
                                            Launch References
                                        </button>
                                    </td>
                                </tr>
                            </table>
                        </form>
                    </td>
                    <td>
                        <table class="sdk-login-table-inputs">
                            <tr *ngIf="!inAdvancedMode">
                                <td colspan="3">
                                    <label class="kc-encoder-phrasecode-text">PhraseCode:</label>
                                    <input
                                        class="kc-encoder-phrasecode-input"
                                        autoCapitalize
                                        [(ngModel)]="SdkTesterService.encoderPhraseCode"
                                        type="text"
                                        id="kc-encoder-phrasecode" />
                                </td>
                            </tr>
                            <tr *ngIf="!inAdvancedMode">
                                <td colspan="3" class="col-md kc-simple-mode-inputs">
                                    <label class="kc-encoder-tab-text">Encoder Tab:</label>
                                    <select id="kc-encoder-tab-dropdown" class="tester-encoder-tab" [(ngModel)]="SdkTesterService.selectedEncoderTab">
                                        <option *ngFor="let et of SdkTesterService.encoderTabs" [value]="et">{{ et }}</option>
                                    </select>
                                </td>
                            </tr>

                            <tr *ngIf="!inAdvancedMode">
                                <td colspan="3" class="col-md kc-simple-mode-inputs">
                                    <label class="kc-state-text">State:</label>
                                    <select
                                        id="kc-state-dropdown"
                                        class="tester-state"
                                        [(ngModel)]="SdkTesterService.selectedI9I10State"
                                        (change)="SdkTesterService.onStateChange()">
                                        <option *ngFor="let ct of SdkTesterService.i9I10States" [ngValue]="ct">{{ ct.value }}</option>
                                    </select>
                                </td>
                            </tr>
                            <tr *ngIf="!inAdvancedMode">
                                <td colspan="3" class="col-md kc-simple-mode-inputs">
                                    <label class="kc-session-type-text">SessionType:</label>
                                    <select id="kc-session-type-dropdown" class="tester-session-type" [(ngModel)]="SdkTesterService.selectedSessionType">
                                        <option *ngFor="let st of SdkTesterService.sessionTypes" [ngValue]="st">{{ st.name }}</option>
                                    </select>
                                </td>
                            </tr>
                            <tr *ngIf="!inAdvancedMode">
                                <td colspan="3" class="col-md kc-simple-mode-inputs">
                                    <label class="kc-patient-type-text">Patient Type:</label>
                                    <select
                                        id="kc-patient-type-dropdown"
                                        class="patient-type"
                                        [(ngModel)]="SdkTesterService.selectedPatientType"
                                        (change)="SdkTesterService.onPatientTypeChange()">
                                        <option *ngFor="let pt of SdkTesterService.patientTypes" [ngValue]="pt">{{ pt.displayValue }}</option>
                                    </select>
                                </td>
                            </tr>

                            <tr *ngIf="!inAdvancedMode">
                                <td colspan="3">
                                    <label>Demographics:</label>
                                    <textarea
                                        name="workflowInput"
                                        id="kc-sdk-sign-in-demographics-input"
                                        placeholder="Demographics input"
                                        spellcheck="false"
                                        [(ngModel)]="SdkTesterService.encoderDemographics"
                                        class="tester-text-area ng-pristine ng-valid ng-touched"></textarea>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
